module.exports = __webpack_public_path__ + "static/logo_notorius_cinema_black-ba1a9814697aed7e69672d0c947d10bb.png";